import { createStore, combineReducers } from 'redux'


export const IMPORT_CURRENT_TAB = 'IMPORT_CURRENT_TAB';
export const IMPORT_RESET_TAB = 'IMPORT_RESET_TAB';
export const IMPORT_CASA = 'IMPORT_CASA';
export const IMPORT_SET_DATA = 'IMPORT_SET_DATA';

export const import_current_tab = (tab) => {
    return {
        type: IMPORT_CURRENT_TAB,
        payload: tab
    }
}
export const import_reset_tab = (tab) => {
    return {
        type: IMPORT_RESET_TAB,
        payload: tab
    }
}

export const import_casa = (tab) => {
  return {
      type: IMPORT_CASA,
      payload: tab
  }
}


export const import_set_data = (data) => {
    return {
        type: IMPORT_SET_DATA,
        payload: data
    }
}

export const import_setRecursos = (data) => {
  return {
      type: 'IMPORT_SET_RECURSOS',
      payload: data
  }
}

const ImportDataGlobal = {
    // tab: 1,
    tab: 1,
    targets: [1],
    casa: 'vacia'
}

const ImportData = {
  typeInformation: -1,
  typeInformationName: '',
  resourceName: '',
  typeResource: -1,
  idFile: '',
  typeFile: 'excel',
  fileName: '',
  resource: -1,
  columsPar: [],
  table: {
    name: '',
    file_structure: [],
    structure: []
  }
  // listResources: []
}

//check localstorage 



const reducerTab =  (state = ImportDataGlobal, action) => {
    switch (action.type) {
      
      case IMPORT_CURRENT_TAB: 
        console.log('mi new tab ', action)
        if (!state.targets.includes(action.payload))
          state.targets.push(action.payload)
        console.log('mi new tab ', state)
        return {
          ...state,
          tab: action.payload
        }
      case IMPORT_RESET_TAB:
        return ImportDataGlobal
      default: {
        return state;
      }
    }
  }

const reducerData =  (state = ImportData, action) => {
    switch (action.type) {
      case IMPORT_SET_DATA: 
        //set localstorage
        console.log('IMPORT_SET_DATA', action, state)
        let res = {
          ...state,
          ...action.payload
        }
        console.log('setear', res)
        return res
      case 'IMPORT_UPDATE_STRUCTURE':
          let {index, col} = action.payload
          console.log(index, col)
          state.table.file_structure = state.table.file_structure.map(item => {
            return item.index === index ? col : item
          })
          
          // if (target !== undefined) {
          //   state.table.file_structure[target].col_table = col.col_table
          // }
          console.log('thistable', state.table)
          return {
            ...state
            // table: {...state.table,}
          }
          break;
      default: 
        return state;
      
    }
  }

export const import_success_import = (data) => {
    return {
        type: 'IMPORT_SUCCESS_IMPORT',
        payload: data
    }
}
const dataProcesar = {
  registros: 0,
  tiempo: 0,
  successRow: 0,
  failRow: 0,
  linkFileError: '',
  linkSuccess: ''
}
const reducerProcesar = (state = dataProcesar, action) => {
    switch (action.type) {
      case 'IMPORT_SUCCESS_IMPORT': 
        let res = {
          ...state,
          ...action.payload
        }
        return res
      default: 
        return state;
      
    }
  }

export default createStore(combineReducers({ 
  reducerTab, reducerData, reducerProcesar
}))
// export default createStore(reducer)